// Обновление LinkedIn followers count
export const initLinkedInStats = async () => {
  const followerElement = document.querySelector('[data-count="724"]');
  if (!followerElement) return;

  try {
    const response = await fetch('/data/linkedin-followers.json');
    if (!response.ok) throw new Error('Failed to fetch followers data');

    const data = await response.json();

    if (data.success && data.count) {
      // Обновляем текст и data-атрибут для анимации счётчика
      followerElement.textContent = data.count;
      followerElement.dataset.count = data.count;

      // Логируем время обновления (опционально)
      const updatedDate = new Date(data.updated);
      console.log(
        `📊 LinkedIn followers обновлено: ${data.count} (${updatedDate.toLocaleString()})`
      );
    }
  } catch (error) {
    console.warn('⚠️ Не удалось загрузить LinkedIn followers:', error.message);
    // Fallback: оставляем старое значение
  }
};

// Переодически обновляем (каждые 30 минут)
export const startLinkedInStatsRefresh = () => {
  // Первое обновление сразу при загрузке
  initLinkedInStats();

  // Затем каждые 30 минут
  setInterval(() => {
    initLinkedInStats();
  }, 30 * 60 * 1000);
};
